import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
// import { useSelector } from 'react-redux'

import { RightArrowIcon, LeftArrowIcon } from 'assets'
import './index.css'

// Carousel config wish list
// const settings_or_props = {
//   infinite: true,
//   dots: true,
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   lazyLoad: true,
//   autoplay: true,
//   autoplaySpeed: 2000,
//   images: []
// };

const CarouselItem = props => {
  const { children, width } = props
  return (
    <div className="custom-carousel-item" style={{ width }}>
      {children}
    </div>
  )
}

const Carousel = props => {
  const { children } = props
  const navigate = useNavigate()
  const location = useLocation()
  const [activeIndex, setActiveIndex] = useState(0)
  // const userInfo = useSelector(state => state.userReducer)
  // const isFreeAccount = userInfo?.user?.accountType !== 'premium'

  useEffect(() => {
    if (location?.pathname?.includes('walkthrough')) {
      const newActiveIndex = localStorage.getItem('walkthroughactiveindex')
      if (newActiveIndex) {
        setActiveIndex(+newActiveIndex)
      }
    }
  }, [location.pathname])

  // console.log('carrousel-props-', { props, children })

  const totalCarouselItemCount = React.Children.count(children)

  const updateIndex = newIndex => {
    if (newIndex < 0) {
      newIndex = 0
    } else if (newIndex >= totalCarouselItemCount) {
      newIndex = totalCarouselItemCount - 1
    }
    // console.log('newIndex-', newIndex)
    localStorage.setItem('walkthroughactiveindex', newIndex)
    setActiveIndex(newIndex)
  }

  return (
    <div className="custom-carousel">
      {/* we will control the active item by using the transform: translateX for the Div.Inner */}
      {/* <div className="inner" style={{ transform: `translateX(-0%)` }}> */}
      <div className="inner" style={{ transform: `translateX(-${activeIndex * 100}%)` }}>
        {/* {children} */}
        {React.Children.map(children, (child, index) => {
          return <React.Fragment key={`slider${index}`}>{React.cloneElement(child, { width: '100%' })}</React.Fragment>
        })}
      </div>
      <div className="indicators">
        {activeIndex > 0 ? (
          <button className="left-indicator" onClick={() => updateIndex(activeIndex - 1)}>
            <LeftArrowIcon />
          </button>
        ) : (
          <span></span>
        )}
        {activeIndex + 1 < totalCarouselItemCount ? (
          <button className="right-indicator" onClick={() => updateIndex(activeIndex + 1)}>
            <RightArrowIcon />
          </button>
        ) : (
          <span></span>
        )}
      </div>
      <div className="indicator-dots noselect">
        {React.Children.map(children, (child, dotIndex) => {
          return (
            <div
              key={`dot${dotIndex}`}
              className={`dot${activeIndex === dotIndex ? ' active-dot' : ''}`}
              onClick={() => updateIndex(dotIndex)}
            />
          )
        })}
      </div>
      {/* DASH-3166 ask to add this to slider */}
      {/* DASH-2500 ask to remove this from slider */}
      {/* {isFreeAccount ? null : ( */}
      <div
        className="skip-to-dashboard"
        onClick={() => {
          // TODO: Redirect to dashboard
          navigate('/')
        }}
      >
        Skip ahead to dashboard
      </div>
      {/* )} */}
    </div>
  )
}

export default Carousel
export { CarouselItem }
